import { memo } from 'react';
import { SVGAssets } from '@business/assets/vectors';
import { Checkbox } from '../../Checkbox';

interface NameCellRendererProps {
  photo: any;
  isChecked: boolean;
  handlePhotoSelect?: (photoId: string) => void;
  handleToggleFavorite?: (
    assetId: string,
    currentFavoriteStatus: string | undefined,
    e?: React.MouseEvent
  ) => void;
  hideCheckbox?: boolean;
  hideFavorite?: boolean;
}

export const NameCellRenderer = memo(
  ({
    photo,
    isChecked,
    handlePhotoSelect,
    handleToggleFavorite,
    hideCheckbox,
    hideFavorite
  }: NameCellRendererProps) => {
    return (
      <div className="flex items-center w-full">
        {!hideCheckbox && (
          <div
            className="w-10 h-10 flex items-center justify-center -ml-3 -my-2 mr-1 cursor-pointer"
            onClick={e => {
              e.stopPropagation();
              handlePhotoSelect?.(photo?.id);
            }}>
            <Checkbox
              name={`${photo?.id}`}
              checked={isChecked}
              onChange={e => {
                e.stopPropagation();
                handlePhotoSelect?.(photo?.id);
              }}
              onClick={e => e.stopPropagation()}
              className="w-4 h-4 text-[#7F9D48] rounded focus:ring-[#7F9D48] focus:ring-2"
            />
          </div>
        )}
        {!hideFavorite && (
          <button
            className="cursor-pointer ml-1"
            onClick={e =>
              handleToggleFavorite?.(photo.id, photo?.favorite?.status, e)
            }>
            {photo?.favorite?.status === 'Active' ? (
              <SVGAssets.YellowFav className="w-5 h-5 mr-2" />
            ) : (
              <SVGAssets.FavoritesIcon className={`w-5 h-5 mr-2 `} />
            )}
          </button>
        )}

        {/* Fixed-width content wrapper */}
        <div className="flex items-center space-x-3 w-[240px]">
          {/* Show Doc or Audio icon if type matches, else show image */}
          {photo?.type === 'document' ? (
            <div className="w-10 h-10 flex items-center justify-center rounded-lg">
              <SVGAssets.DocIcon className="w-7 h-7 text-gray-400" />
            </div>
          ) : photo?.type === 'audio' ? (
            <div className="w-10 h-10 flex items-center justify-center rounded-lg">
              <SVGAssets.Audio className="w-7 h-7 text-gray-400" />
            </div>
          ) : (
            <img
              loading="lazy"
              src={photo?.thumbNailUrl || '/placeholder-image.jpg'}
              alt={photo?.fileName || 'Photo'}
              className="w-10 h-10 rounded-lg object-cover flex-shrink-0"
            />
          )}

          <span className="text-sm font-medium text-gray-900 truncate">
            {photo?.fileName || 'photo.png'}
          </span>
        </div>
      </div>
    );
  }
);
